var XPortal = XPortal || {};
XPortal.inputHandler =
{
    ControlSelector: ".input-group",
    Init: function (container) {
        var self = this;
        self.clearInput(container)
    },
    clearInput: function (container) {
        var self = this;
        var modelName = XPortal.Store.getModelName(container[0].id);
        var $inputsGroups = container.find(this.ControlSelector);
        var knownInputs = [];
        container.off('.inputHandler');

        $inputsGroups.each(function () {
            var $group = $(this);
            var $input = $group.find('input.form-control');
            var sttgs = XPortal.Main.GetSettingsFor($input);

            var checkValue = function () {
                var currentInput = $group.find('input.form-control');
                if (currentInput.val()) {
                    $group.addClass('input-group-focus');
                } else {
                    $group.removeClass('input-group-focus');
                }
            };

            checkValue();

            knownInputs.push(
                {
                    $group,
                    checkValue,
                    fname: sttgs.fieldname ? sttgs.fieldname.toLowerCase() : ""
                }
            );
        });
        container.on(
            'focus.inputHandler blur.inputHandler change.inputHandler input.inputHandler dispatchFieldEvent.inputHandler',
            this.ControlSelector + ' input.form-control',
            function () {
                var $input = $(this);
                var $group = $input.closest(self.ControlSelector);
                if ($input.val()) {
                    $group.addClass('input-group-focus');
                } else {
                    $group.removeClass('input-group-focus');
                }
            }
        );

        container.on('click.inputHandler', this.ControlSelector + ' .btn-clear', function () {
            var $group = $(this).closest(self.ControlSelector);
            var $input = $group.find('input.form-control');
            var sttgs = XPortal.Main.GetSettingsFor($input);

            if (sttgs && sttgs.meta && sttgs.meta.fieldname) {
                XPortal.Store.FieldEvent($input, "", modelName, sttgs);
            } else {
                $input.val('');
            }
            $group.removeClass('input-group-focus');
        });

        container.on('click.inputHandler', this.ControlSelector + ' .btn-show-pass', function (event) {
            event.preventDefault();
            var $group = $(this).closest(self.ControlSelector);
            var $input = $group.find('input.form-control');

            $input[0].setSelectionRange($input.val().length, $input.val().length);
            $input.attr('type', $input.attr('type') === 'password' ? 'text' : 'password');

            var $btn = $(this);
            $btn.find(".showPasswordIcon").toggleClass("d-none");
            $btn.find(".hidePasswordIcon").toggleClass("d-none");
            $input.focus();
        });

        if (!XPortal.Store.AppStore) XPortal.Store.Init();
        if (container.data('inputHandlerUnsubscribe')) {
            container.data('inputHandlerUnsubscribe')();
        }

        var unsubscribe = XPortal.Store.AppStore.subscribe(() => {
            var state = XPortal.Store.AppStore.getState();
            var lasteAction = state.lastAction;
            if (lasteAction && lasteAction.field && lasteAction.field.field) {
                knownInputs.forEach(x => {
                    if (x.fname == lasteAction.field.field)
                        x.checkValue();
                });
            }
        });

        container.data('inputHandlerUnsubscribe', unsubscribe);
    }
};